import {Image} from 'react-native';
import Localized from 'src/constants/AppStrings';
import Logo from 'src/components/elements/Logo';
import Styles from 'src/components/Styles';

export function getLogoGradientProps() {
  return {
    colors: ['#FFFFFF', '#FBFFF3', '#E3F4C0', '#A5CF4F'],
    locations: [0, 0.3, 0.7, 1],
    start: {x: 0.5, y: 0},
    end: {x: 0.5, y: 1},
  };
}

export function getWelcomeLogoImage() {
  return (
    <Image
      source={require('src/components/img/CantenWelcome.png')}
      style={{width: 338, height: 298}}
      resizeMode="cover"
    />
  );
}

export function getLoginLogo(): JSX.Element {
  return <Logo width={126} height={126} />;
}

export function getWelcomeDescriptionText(): string {
  return Localized.Labels.welcome_text;
}

export function getWelcomeDescriptionTextStyle() {
  return {
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 24,
  };
}

export function getLoginButtonColor() {
  return '#003349';
}

export default {
  getLogoGradientProps,
  getWelcomeLogoImage,
  getLoginLogo,
  getWelcomeDescriptionTextStyle,
  getWelcomeDescriptionText,
  getLoginButtonColor,
};
